import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failurelistBilling, successlistBilling } from "./ListBillingSlice";

// list
const ListBillingApi = () => {
  return api.get("/api/settings/billing");
};

export function* ListBillingCall() {
  try {
    const response: AxiosResponse = yield call(ListBillingApi);
    yield put(successlistBilling(response.data));
  } catch (error) {
    yield put(failurelistBilling(error));
  }
}
